module.exports = __webpack_public_path__ + "media/front/ico-calculator-f34658bf.svg";